import Section, { SectionProps } from '@lyra/core/components/Section'
import TransactionsTable from '@lyra/web/components/common/TransactionsTable'
import useTransaction from '@lyra/web/hooks/useTransaction'
import React from 'react'

type Props = SectionProps

export default function PendingTransactionsSection({ ...sectionProps }: Props) {
  const { pendingBridges } = useTransaction()

  return (
    <Section {...sectionProps}>
      <Section.Header title="Pending Transactions" />
      <Section.Table>
        <TransactionsTable transactions={pendingBridges} />
      </Section.Table>
    </Section>
  )
}
